import { ReactNode } from 'react';

import s from '@/components/survey/common/ui/styles/BasicList.module.scss';

export const BasicList = ({ children }: { children: ReactNode }) => {
  return (
    <div className={s.list}>
      <p className={s.text}>{children}</p>
    </div>
  );
};
